import constants from '@/constants';
import { getToken } from '@/scripts/token.js';
import store from '@/store/index.js';
import { axiosRequest, METHOD } from '@/api/default.js';

export async function getFiltersAxios(assetTypeID = null) {
    const token = await getToken();
    if (token === null) {
        throw 'Authorization token was not detected';
    }

    const assetTypes = await calculateAssetType(assetTypeID);

    const paramsList = [];
    for (let index = 0; index < assetTypes.length; index++) {
        paramsList.push({
            method: 'GET',
            url: `${process.env.VUE_APP_BACKEND_URL}${constants.URL.FILTER_GET}`,
            params: {
                asset_type_id: assetTypes[index],
            },
            headers: {
                Authorization: token,
                'Cache-Control': 'no-cache',
            },
        });
    }

    return paramsList;
}

export async function getFilters(assetTypeID = null) {
    const assetTypes = await calculateAssetType(assetTypeID);
    const paramsList = [];

    for (let index = 0; index < assetTypes.length; index++) {
        const response = await axiosRequest({
            url: constants.URL.FILTER_GET,
            method: METHOD.GET,
            requestName: 'GET FILTER',
            params: {
                asset_type_id: assetTypes[index],
            },
            isLoader: false,
        });

        paramsList.push(response == null ? [] : response);
    }

    return paramsList;
}

async function calculateAssetType(assetTypeID) {
    const assetTypes = [];
    if (assetTypeID == null) {
        const allAssetTypes = await store.getters.ASSET_TYPES;
        allAssetTypes.forEach((assetTypeValue, assetTypeIndex) => {
            assetTypes.push(assetTypeValue.id);
        });
    } else {
        assetTypes.push(assetTypeID);
    }

    return assetTypes;
}

export async function createFilter(data) {
    if (data.parent_id === 'None') {
        data.parent_id = null;
    }

    const response = await axiosRequest({
        url: constants.URL.FILTER_CREATE,
        method: METHOD.POST,
        requestName: 'CREATE FILTER',
        data: data,
    });

    return response;
}

export async function updateFilter(data) {
    const response = await axiosRequest({
        url: constants.URL.FILTER_UPDATE,
        method: METHOD.PUT,
        requestName: 'UPDATE FILTER',
        data: data,
    });

    return response == null ? false : true;
}

export async function deleteFilter(id) {
    const response = await axiosRequest({
        url: constants.URL.FILTER_DELETE,
        method: METHOD.DELETE,
        requestName: 'DELETE FILTER',
        params: {
            filter_id: id,
        },
    });

    return response == null ? false : true;
}

export async function createFilterItem(data) {
    const response = await axiosRequest({
        url: constants.URL.FILTER_ITEM_CREATE,
        method: METHOD.POST,
        requestName: 'CREATE FILTER ITEM',
        data: data,
    });

    return response;
}

export async function updateFilterItem(data) {
    const response = await axiosRequest({
        url: constants.URL.FILTER_ITEM_UPDATE,
        method: METHOD.PUT,
        requestName: 'UPDATE FILTER ITEM',
        data: data,
    });

    return response == null ? false : true;
}

export async function deleteFilterItem(id) {
    const response = await axiosRequest({
        url: constants.URL.FILTER_ITEM_DELETE,
        method: METHOD.DELETE,
        requestName: 'DELETE FILTER ITEM',
        params: {
            filter_item_id: id,
        },
    });

    return response == null ? false : true;
}

export async function updateFilterImage(file, filterID) {
    const data = new FormData();
    data.append('icon_image', file, file.name);

    const response = await axiosRequest({
        url: constants.URL.FILTER_SET_ICON,
        method: METHOD.PUT,
        requestName: 'UPDATE FILTER ICON',
        isFile: true,
        data: data,
        params: {
            filter_id: filterID,
        },
    });

    return response;
}
